import { restClient } from '../config/restClient'

export const getTeammateInvite = async token => {
  const response = await restClient(`/api/company/v2/teammate_invites/${token}`, {
    method: 'GET',
  })

  return response.data
}
